import { MapperBase } from '../../utilities/mapper-base';
import { FileRecord } from '../ui/file.model';
import { DownloadBriefcaseFileRequestResource } from '../resource/download-briefcase-file-request.resource';
import { FileTypeToFileTypeResourceMapper } from './file-type-to-file-type-resource.mapper';

const fileTypeToFileTypeResourceMapper = new FileTypeToFileTypeResourceMapper();

export class FileToDownloadBriefcaseFileRequestResourceMapper extends MapperBase<FileRecord, DownloadBriefcaseFileRequestResource> {
	map(source: FileRecord): DownloadBriefcaseFileRequestResource {
		return {
			fileId: source.id,
			fileType: fileTypeToFileTypeResourceMapper.map(source.type)
		};
	}
}
